<template>
  <div>
    <v-btn
      text
      color="primary"
      @click="toggleLogging"
    >
      Toggle Logging
    </v-btn>
    <v-btn
      text
      @click="testLog"
    >
      Test log
    </v-btn>
    <v-btn
      text
      color="warning"
      @click="clearLogs"
    >
      Clear Logs
    </v-btn>
    <hr>

    <p
      v-for="(log, i) in logs"
      :key="i"
      class="linebreaks"
    >
      {{ log }}
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Console",
    computed: {
        ...mapState({
            logs: state => state.logs
        })
    },

    methods: {

        clearLogs() {
            this.$store.dispatch('clearLogs')
        },

        toggleLogging() {
            this.$store.dispatch('toggleLogging')
        },

        testLog() {
            console.log('Testing log')
        }
    }
}
</script>